import clsx from "clsx";
import React, { forwardRef } from "react";
import { FormattedMessage } from "react-intl";

import { useSelector } from "../../hooks";

interface PostcodeProps {
	id: string;
	label: string;
	autoComplete: string;
	placeholder?: string;
	className?: string;
	value?: string;
	error?: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const Postcode = forwardRef<HTMLInputElement, PostcodeProps>(
	(props, ref) => {
		const {
			id,
			label,
			autoComplete,
			placeholder,
			className,
			value,
			error,
			onChange,
		} = props;

		const country = useSelector((state) => state.settings.country);

		const config = {
			no: {
				pattern: "[0-9]{4}",
				length: 4,
			},
			dk: {
				pattern: "[0-9]{4}",
				length: 4,
			},
			se: {
				pattern: "[0-9]{3} [0-9]{2}",
				length: 6,
			},
		};

		return (
			<div
				className={clsx({
					[`${className}`]: true,
					error: error,
					valid: value && !error,
				})}
			>
				<label className="label" htmlFor={id}>
					{label}
				</label>
				<input
					ref={ref}
					onChange={onChange}
					className="field"
					id={id}
					type="text"
					maxLength={config[country].length}
					pattern={config[country].pattern}
					placeholder={placeholder}
					aria-invalid={!!error}
					autoComplete={autoComplete}
					data-automationid={id}
					data-testid={`${id}.input`}
				/>
				{error && (
					<span
						className="errorMessage"
						data-automationid={`${id}.error`}
						data-testid={`${id}.error`}
					>
						<FormattedMessage id={error} values={{ fieldname: label }} />
					</span>
				)}
			</div>
		);
	},
);
